import React, { useState } from 'react';

function TaskHistory({
  history,
  setHistory,
  taskStatuses,
  setTaskStatuses,
  onCheckStatus,
  onClear,
}) {
  const [statusFilter, setStatusFilter] = useState('全部');
  const [searchTerm, setSearchTerm] = useState('');

  /* ---------- 工具函数 ---------- */
  const handleDelete = (taskId) => {
    const updated = history.filter((t) => t.task_id !== taskId);
    const updatedStatuses = { ...taskStatuses };
    delete updatedStatuses[taskId];
    setHistory(updated);
    setTaskStatuses(updatedStatuses);
    localStorage.setItem('task_history', JSON.stringify(updated));
  };

  const statusBadge = (status) => {
    if (status === 'done')
      return <span className="status-complete">✅ 已完成</span>;
    if (status === 'running')
      return <span className="status-running">⏳ 运行中</span>;
    if (status === 'error')
      return <span className="status-failed">❌ 错误</span>;
    return <span className="status-unknown">未知</span>;
  };

  /* ---------- 过滤 ---------- */
  const filtered = history.filter((task) => {
    const kw = searchTerm.toLowerCase();
    const matchesKeyword =
      task.type?.toLowerCase().includes(kw) ||
      task.method?.toLowerCase().includes(kw) ||
      task.time?.toLowerCase().includes(kw);

    const currentStatus = taskStatuses?.[task.task_id]?.status || task.status;
    const matchesStatus = statusFilter === '全部' || currentStatus === statusFilter;
    return matchesKeyword && matchesStatus;
  });

  /* ---------- 渲染 ---------- */
  return (
    <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-xl mt-6">
      {/* 顶部工具条 --------------------------------------------------- */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-4">
        <input
          type="text"
          placeholder="🔍 搜索任务类型 / 方法 / 时间"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="flex-1 p-2 border rounded-lg dark:bg-gray-700 dark:text-white"
        />

        <div className="flex items-center gap-2">
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="p-2 border rounded dark:bg-gray-700 dark:text-white"
          >
            <option value="全部">全部</option>
            <option value="running">运行中</option>
            <option value="done">已完成</option>
            <option value="error">错误</option>
          </select>

          <button
            onClick={onClear}
            className="btn-action btn-delete whitespace-nowrap"
          >
            🗑 清空所有
          </button>
        </div>
      </div>

      {/* 任务表格 ----------------------------------------------------- */}
      <div className="overflow-x-auto">
        <table className="task-table">
          <thead>
            <tr>
              <th className="col-id">任务&nbsp;ID</th>
              <th>类型</th>
              <th>方法</th>
              <th>状态</th>
              <th>操作</th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((task) => {
              const statusObj = taskStatuses?.[task.task_id] || {};
              const status = statusObj.status || task.status;

              return (
                <tr key={task.task_id}>
                  <td className="col-id font-mono">{task.task_id.slice(0, 8)}…</td>
                  <td>{task.type}</td>
                  <td>{task.method}</td>
                  <td>{statusBadge(status)}</td>

                  {/* ---------- 操作按钮组 ---------- */}
                  <td>
                    <button
                      onClick={() => onCheckStatus(task.task_id)}
                      className="btn-action btn-refresh"
                    >
                      🔄 刷新
                    </button>

                    {status === 'done' && statusObj.file && (
                      <a
                        href={`http://localhost:5001/download_result?filename=${statusObj.file}`}
                        className="btn-action btn-download"
                        download
                      >
                        ⬇ 下载结果
                      </a>
                    )}

                    <button
                      onClick={() => handleDelete(task.task_id)}
                      className="btn-action btn-delete"
                    >
                      ❌ 删除
                    </button>
                  </td>
                </tr>
              );
            })}

            {filtered.length === 0 && (
              <tr>
                <td colSpan="5" className="text-center py-6 text-gray-500 dark:text-gray-400">
                  暂无匹配的任务记录
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TaskHistory;

